import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import PublisherEditor from "@/pages/publisher/PublisherEditor";
import AdminLayout from "@/pages/admin/AdminLayout";

export const Route = createFileRoute("/admin/content/$id")({
  head: () => pageHead("Admin \u2014 Content \u2014 Id \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: () => (
    <PublisherEditor mode="edit" basePath="/admin/content" Shell={AdminLayout} />
  ),
});
